import { normalize } from 'normalizr';
import userInfo from 'utils/userInfo';
import {
  amenityApi,
  cityApi,
  cuisineApi,
  curatorApi,
  eateryApi,
  fileApi,
  tagApi,
} from 'api';
import {
  amenitySchema,
  citySchema,
  cuisineSchema,
  eaterySchema,
  tagSchema,
} from 'schemas';
import { operations as entitiesOps } from 'schemas/duck';
import actions from './actions';

const { mergeEntities } = entitiesOps;

const fetchEateryBySlug = slug => dispatch =>
  eateryApi
    .getBySlug(slug, { includeCuratorTips: true })
    .then(({ data: { data: { curatorTips, entity } } }) =>
      dispatch(
        mergeEntities(
          normalize({ ...entity, curatorTips }, eaterySchema).entities
        )
      )
    );

const fetchAmenities = () => dispatch =>
  amenityApi
    .get()
    .then(({ data }) =>
      dispatch(mergeEntities(normalize(data, [amenitySchema]).entities))
    );

const fetchCities = () => dispatch =>
  cityApi
    .get()
    .then(({ data }) =>
      dispatch(mergeEntities(normalize(data, [citySchema]).entities))
    );

const fetchCuisines = () => dispatch =>
  cuisineApi
    .get()
    .then(({ data }) =>
      dispatch(mergeEntities(normalize(data, [cuisineSchema]).entities))
    );

const fetchTags = () => dispatch =>
  tagApi
    .get()
    .then(({ data }) =>
      dispatch(mergeEntities(normalize(data, [tagSchema]).entities))
    );

const upsertEatery = (eatery, tips) => dispatch => {
  const images = [
    eatery.mainImage,
    ...eatery.galleryImages,
    ...eatery.menuImages,
  ].filter(({ file }) => !!file);

  dispatch(actions.setIsSaving(true));

  (images.length
    ? fileApi.postMultiple(images.map(({ file }) => file)).then(({ data }) =>
        data.forEach(({ fileDownloadUri }, index) => {
          images[index].uri = fileDownloadUri;
          delete images[index].file;
        })
      )
    : Promise.resolve()
  )

    .then(() => {
      if (eatery.id) {
        eateryApi.put(eatery).then(res => {
          // console.log('put response', res, tips);

          tips.post.map(t => {
            return curatorApi.postTip(t);
          });
          tips.del.map(d => curatorApi.deleteTip(d));
          tips.put.map(p => curatorApi.putTip(p));
        });
      } else {
        eateryApi.post(eatery).then(res => {
          // console.log('put response', res);
          tips.map(i =>
            curatorApi.postTip({
              resourceId: res.data.data.id,
              tip: i,
              owner: {
                id: userInfo.getUserID(),
              },
            })
          );
        });
      }
    })
    .then(({ data: { data } }) => {
      const { entities, result } = normalize(data, eaterySchema);
      dispatch(mergeEntities(entities));
      dispatch(actions.setEditedSlug(result));
    })
    .catch(() => {})
    .then(() => dispatch(actions.setIsSaving(false)));
};

export default {
  fetchEateryBySlug,
  fetchAmenities,
  fetchCities,
  fetchCuisines,
  fetchTags,
  upsertEatery,
};
